const LEAD_DETAILS_PATH = /^\/leads\/details\/([^/]+)/;

// lead id of a /leads/details/<leadId>/… path, undefined on any other page
export const getLeadDetailsId = (pathname: string) => LEAD_DETAILS_PATH.exec(pathname)?.[1];
